<div class="px-3 h-100">
    <div class="row h-100 justify-content-center align-items-center">
        <div class="col-auto">
            <div class="alert alert-info m-0">
                <div class="col">
                    <div class="row mb-2">
                        <div class="col">
                            {{
                                'Der konfigurierte Server antwortet leider nicht. Versuchen Sie es bitte später erneut oder kontaktieren Sie einen Administrator.'
                                    | translate
                            }}
                        </div>
                    </div>
                    <div class="row">
                        <div class="col-auto">
                            <span class="text-secondary cursor-pointer hoverable" (click)="changeApiUrl()">
                                {{ 'Serverkonfiguration ändern' | translate }}
                            </span>
                            <br />
                            <span class="text-primary cursor-pointer hoverable" [routerLink]="View.CLIENT + '/login'">
                                {{ 'neu laden' | translate }}
                            </span>
                        </div>
                    </div>
                </div>
            </div>
        </div>
    </div>
</div>
